import React, { FC } from 'react';
import { RodRequestDrawerProps } from './types';
import {
  Box,
  Button,
  ButtonAppearance,
  ButtonSize,
  SideSheetBody,
  SideSheetContentCol,
  SideSheetFooter,
} from '@bechtel/gds';
import { Form, Formik, Field } from 'formik';
import { DrawerCloseStyled, DrawerFooterButtonStyled, DrawerHeaderStyled } from '@bechtel/client-common';
import { t, Trans } from '@lingui/macro';
import { SearchByList } from './search-by-list';
import { PickupTimeList } from './pickup-time-list';
import { DrawerBackdropStyled, DrawerOuterStyled } from './styled';
import { SortByList } from './sort-by-list';
import { drawerValues } from './form-state';
import { isEqual } from 'lodash';

export const RodRequestDrawer: FC<RodRequestDrawerProps> = ({ close, onSubmit, initialValues }) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { resetForm }) => {
        resetForm();
        close();
        onSubmit(values);
      }}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ isValid, dirty, setValues, values }) => {
        return (
          <Form data-testid="drawer-container">
            <DrawerBackdropStyled>
              <DrawerOuterStyled>
                <DrawerHeaderStyled title={t`Filters`}>
                  <DrawerCloseStyled onClick={close} data-testid="drawer-close-button"></DrawerCloseStyled>
                </DrawerHeaderStyled>
                <SideSheetBody>
                  <SideSheetContentCol>
                    <Field name="sortByList" component={SortByList} />
                    <Field name="searchByList" component={SearchByList} />
                    <Field name="pickupTimeList" component={PickupTimeList} />
                    <Box p={{ sm: '500' }}>
                      <Button
                        data-testid="reset-button"
                        size={ButtonSize.MEDIUM}
                        css={`
                          color: ${({ theme }) => theme.colors.blue[800]};
                          font-weight: ${({ theme }) => theme.fontWeights[600]};
                        `}
                        appearance={ButtonAppearance.SECONDARY}
                        disabled={isEqual(drawerValues, values)}
                        onClick={() => {
                          setValues(drawerValues);
                        }}
                      >
                        <Trans>Reset All Filters</Trans>
                      </Button>
                    </Box>
                  </SideSheetContentCol>
                </SideSheetBody>
                <SideSheetFooter>
                  <Box justifyContent={{ sm: 'flex-end' }}>
                    <Box mr={{ sm: '400' }}>
                      <DrawerFooterButtonStyled
                        data-testid="cancel-button"
                        size={ButtonSize.MEDIUM}
                        appearance={ButtonAppearance.SECONDARY}
                        onClick={close}
                      >
                        <Trans>Cancel</Trans>
                      </DrawerFooterButtonStyled>
                    </Box>
                    <Box>
                      <DrawerFooterButtonStyled
                        data-testid="apply-filter-button"
                        type="submit"
                        size={ButtonSize.MEDIUM}
                        appearance={ButtonAppearance.SECONDARY}
                        disabled={!dirty || !isValid}
                      >
                        <Trans>Apply Filters</Trans>
                      </DrawerFooterButtonStyled>
                    </Box>
                  </Box>
                </SideSheetFooter>
              </DrawerOuterStyled>
            </DrawerBackdropStyled>
          </Form>
        );
      }}
    </Formik>
  );
};
